import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=375b39a1&scoped=true&"
import script from "./RegisterUser.vue?vue&type=script&lang=js&"
export * from "./RegisterUser.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=375b39a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b39a1",
  null
  
)

export default component.exports